import React, { forwardRef, Ref } from 'react';
import { SimpleIconProps } from '../icon.types';
import Icon from './Icon';

const svg = `<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
  <rect width="18" height="18" x="3" y="3" rx="2"/>
  <path style="stroke-width: var(--stroke-width)" d="m9 12 2 2 4-4"/>
</svg>`;

const Checkbox = forwardRef(
  (props: SimpleIconProps, ref: Ref<SVGSVGElement> | undefined) => (
    <Icon ref={ref} name='checkbox' svg={svg} {...props} />
  )
);

Checkbox.displayName = 'CheckboxIcon';

export default Checkbox;
